/**
 * Fetches the stop-to-lines mapping from the FlowRide backend.
 */

import axios from "axios";

import type { StopLinesMappingResponseDto } from "../types/dtos/api/stop-lines.dto";

const STOP_LINES_REQUEST_TIMEOUT_MS = 10_000;

/** Empty index returned when the request fails so lookups degrade to "no lines". */
const EMPTY_STOP_LINES_INDEX: StopLinesMappingResponseDto = {
    "lines":   {},
    "aliases": {},
};

/**
 * @returns Stop-lines index (`lines` + `aliases`), or an empty index when the request fails.
 */
export const fetchStopLinesMapping = async(): Promise<StopLinesMappingResponseDto> => {
    try {
        const { data } = await axios.get<StopLinesMappingResponseDto>(
            "/api/stops/lines",
            { "timeout": STOP_LINES_REQUEST_TIMEOUT_MS },
        );

        return {
            "lines":   data.lines ?? {},
            "aliases": data.aliases ?? {},
        };
    } catch( error: unknown ) {
        console.warn( "[StopLinesApi] Failed to fetch stop lines mapping", error );

        return EMPTY_STOP_LINES_INDEX;
    }
};
